import * as z from "zod";
import { LabelDimensionsSchema } from "./purchase-label";

export const getLabelDimensions = {
  name: "getLabelDimensions" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({
    /**
     * The package size a return label is quoted with when the merchant enters
     * none: the returned products' learned size, else the team's default box.
     */
    dimensions: LabelDimensionsSchema.optional(),
  }),
};
